// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 2C4.79086 2 3 3.79086 3 6V18C3 20.2091 4.79086 22 7 22H21V2H7ZM17 9.75L14.5 7.6875L12 9.75V4H17L17 9.75ZM5 18C5 16.8954 5.89543 16 7 16H19V20H7C5.89543 20 5 19.1046 5 18Z"}}]};

const AddressBookFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'address-book-filled',
    ref,
    icon: element,
  },
));

AddressBookFilledIcon.displayName = 'AddressBookFilledIcon';

export default AddressBookFilledIcon;
